import Header from "../../Common/Header";
import PricingPage from "../Pricing/Pricing/Pricing";
export default function Pricing() {
  return (
    <main>
      <Header />
      <PricingPage />
    </main>
  );
}
